export default __webpack_public_path__ + "static/media/RootsGoods_App.5be0512f.png";